import "../menu/top-menu";

const DAY_MS = 86400000;

class OfferRequest {
  startDate: Date;
  endDate: Date;
  adults: number;
  children: number;
  toJsonString() {
    return JSON.stringify(this);
  }
};

interface OfferPriceDetail {
  description: string;
  units: number;
  pricePerUnit: number;
  price: number;
};
interface OfferResponse {
  startDate: Date;
  endDate: Date;
  available: boolean;
  price: number;
  priceDetails: Array<OfferPriceDetail>;
};

class ConstDavosBooking extends HTMLDivElement {
  private startInput: HTMLInputElement;
  private endInput: HTMLInputElement;
  private peopleInput: HTMLSelectElement;
  private offer: HTMLElement;
  private templateSrc : DocumentFragment;

  connectedCallback() {
    this.startInput = this.querySelector("#start");
    this.endInput = this.querySelector("#end");
    this.peopleInput = this.querySelector("#people");
    this.offer = this.querySelector(".offer");
    this.templateSrc = this.querySelector("template").content;
    let todayTime = new Date().getTime();
    this.startInput.valueAsDate = new Date(todayTime + DAY_MS);
    this.endInput.valueAsDate = new Date(todayTime + 7 * DAY_MS);
    this.startInput.addEventListener("change", () => this.onQueryChange());
    this.endInput.addEventListener("change", () => this.onQueryChange());
    this.peopleInput.addEventListener("change", () => this.onQueryChange());
  }
  private onQueryChange() {
    this.setOfferSearch();
    let request:OfferRequest = this.makeOfferRequest();
    fetch("/api/get-offer", {
      method: "POST",
      cache: 'no-cache',
      headers: { 'Content-Type': 'application/json' },
      body: request.toJsonString()
    }).then(response => response.json())
    .then(data => this.setOfferData(data))
    .catch(error => this.setOfferError(error));
  }
  private makeOfferRequest(): OfferRequest {
    let request = new OfferRequest();
    request.startDate = this.startInput.valueAsDate;
    request.endDate = this.endInput.valueAsDate;
    request.adults = parseInt(this.peopleInput.selectedOptions[0].dataset.adults);
    request.children = parseInt(this.peopleInput.selectedOptions[0].dataset.children);
    return request;
  }
  private setOfferSearch() {
    this.setOfferContent(this.templateSrc.querySelector(".search").cloneNode(true) as HTMLElement);
  }
  private setOfferData(offerResponse: OfferResponse) {
    if (!offerResponse.available) {
      this.setOfferContent(this.templateSrc.querySelector(".unavailable").cloneNode(true) as HTMLElement);
      return;
    }
    let offerContent = this.templateSrc.querySelector(".unavailable").cloneNode(true) as HTMLElement;
    offerContent.querySelector("time.start").textContent = offerResponse.startDate.toLocaleString();
    offerContent.querySelector("time.end").textContent = offerResponse.startDate.toLocaleString();
    offerContent.querySelector(".price").textContent = offerResponse.price.toString();
    this.setOfferContent(offerContent);
  }
  private setOfferError(error) {
    let errorContent = this.templateSrc.querySelector(".error").cloneNode(true) as HTMLElement;
    errorContent.querySelector("span.details").textContent = error;
    this.setOfferContent(errorContent);
  }
  private setOfferContent(content: HTMLElement) {
    this.offer.innerHTML = '';
    this.offer.appendChild(content);
  }
}

customElements.define('const-davos-booking', ConstDavosBooking, {extends: 'div'});
